import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { conversationalTerritories } from "./constants";
import type { ConversationalTerritoriesResult } from "./types";
import { isConversationalTerritoriesResult } from "./validators";

/**
 * GET handler for the "/:app_group_id/conversational/territories" endpoint: the teams used by the
 * workflows the developer may view.
 */
export const getConversationalTerritories = reactQueryFetcherAdapter(
  conversationalTerritories,
  (signal: AbortSignal, appGroupId: string): Promise<ConversationalTerritoriesResult> => {
    return fetch(`/${appGroupId}/conversational/territories`, "GET", {}, { signal });
  },
  isConversationalTerritoriesResult
);
